import { Button, CounterPill } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';

export interface IAddTranslationsButtonProps {
	onClick: () => void;
	numberOfSupportedLanguages: number;
	numberOfTranslations: number;
	checkThreshold?: boolean;
	loading: boolean;
	disabled?: boolean;
}

export const AddTranslationsButtonContainer = styled.div`
	text-align: right;
	width: 100%;
	position: relative;

	.tws-counter-pill {
		position: absolute;
		right: -23px;
		bottom: -12px;
	}
	@media (max-width: 795px) {
		margin-top: 10px;
	}
`;

export class AddTranslationsButton extends React.Component<IAddTranslationsButtonProps> {
	public static defaultProps: Partial<IAddTranslationsButtonProps> = {
		checkThreshold: true,
	};
	public render() {
		const { loading, disabled } = this.props;
		return (
			<AddTranslationsButtonContainer>
				<Button disabled={disabled} onClick={this.props.onClick} className='tws-add-translations-button'>
					Add Translations
				</Button>
				{!loading && (
					<CounterPill
						size='sm'
						expectedCount={this.props.numberOfSupportedLanguages}
						actualCount={this.props.numberOfTranslations}
						checkThreshold={this.props.checkThreshold}
					/>
				)}
			</AddTranslationsButtonContainer>
		);
	}
}
